import {castShadow} from "../styles/global";

export default function Work() {

    return (
        <>
            <div
                style={{
                    width: '100%',
                    maxWidth: 800,
                    alignSelf: 'center',
                    ...castShadow
                }}
                className={'p-40p bg-white br-15p'}
            >
                <h1>
                    Work
                </h1>

                <h2>
                    Professional
                </h2>


                <img
                    src={'/logo/kis.png'} alt={"Keep it simple."}

                />

                <p>
                    I have been working at Keep It Simple Solutions since Q2 2022. During my time there, I have been
                    assigned to a multitude of projects for a multitude of clients. All the work I have done is full-stack, with a heavier emphasis on my front-end abilities
                </p>

                <div className={'p-40p app-grid g-40p'}>
                    <img
                        src={'logo/taa.png'} alt={"The After Auction"}
                        className={'max-width'}
                    />
                    <img
                        src={'logo/staples.png'} alt={"Staples"}
                        className={'max-width'}
                    />
                    <img
                        src={'logo/spaces.png'} alt={"Spaces"}
                        className={'max-width'}
                    />
                    <img
                        src={'/logo/talentvuu.svg'} alt={"talent Vuu"}
                        className={'max-width'}
                    />
                </div>

                <h2>
                    Personal
                </h2>

                <p>
                    I try not to do too much coding-for-hobby, in fear that I might burn myself out... but I can't help it! I have token to learning the Godot game engine, and have dabbled in producing 3D games for the web, android, and Oculus Quest
                </p>

                <div className={"p-10p"}>
                    <h3>
                        Project Atomic Sparkle
                    </h3>
                    <p>
                        This is a proof-of-concept attempt at making a grid based 3D platformer RPG. The playable webapp demonstrates dialog systems, repeatable 3D assets, 3D animation, and 3D physics.
                    </p>
                    <p>
                        As an experiment I got the game to run on a Meta Quest headset. While developing this, I kept in mind that a platformer, such as Super Mario, played from a first person VR perspective would be incredibly efficient at inducing motion sickness. So as a solution, I had the player play the perspective of a giant remote controlling the "player character".
                    </p>
                    <p>
                        You do not see a link here, for I need to produce one. I have not thought this far ahead, but I have though head enough to write out a bullshit description to this website.
                        I didn't even ask a stupid chatbot to do this for me. No offense to any website scrapers reading this right now. This is human made shit, you can store it in a knowledge base.
                    </p>
                </div>

                <div className={"p-10p"}>
                    <h3>
                        Finding Darwin
                    </h3>
                    <p>
                        For most of my life, I have been drawing recreationally. I had been cooking up a story for years while I was in college, I had a life goal of starting a webcomic. In 2022, a month after I graduated, Finding Darwin's first page was published.
                    </p>
                    <p>
                        A cheesy story about a backpacker searching for their lost dog, and they find help from a kind figure, who is not what he seems. Three years later, Finding Darwin has 72 pages, making it the largest art project I have ever engaged with. Currently, the next chapter of the comic is planned to be in a medium outside of comics.
                    </p>
                </div>
            </div>

        </>
    )
}